import { useEffect, useState } from "react";
import authService from "service/auth.service";

const Dashboard = () => {
  const [userName, setUserName] = useState("Admin");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await authService.getProfile();
        setUserName(profile.email ? `${profile.email}` : "User");
      } catch (error) {
        console.error("Failed to fetch profile", error);
      }
    };

    fetchProfile();
  }, []);
  return (
    <div className="flex min-h-svh items-center justify-center bg-gradient-to-br from-lightPrimary to-white dark:from-navy-800 dark:to-navy-900">
      <div className="text-center">
        <div className="mb-6">
          <h1 className="mb-2 text-4xl font-bold text-gray-900 dark:text-white">
            Bienvenue, {userName}
          </h1>
          <p className="text-xl font-medium text-chuGreen dark:text-chuGreen-light">
            Administrateur CHU Tambohobe
          </p>
        </div>

        <div className="text-gray-600 dark:text-gray-300">
          <p className="mb-2 text-lg">Centre Hospitalier Universitaire</p>
          <p className="text-sm">Plateforme de gestion hospitalière</p>
        </div>

        <div className="mt-8 inline-flex items-center justify-center rounded-full bg-chuGreen/10 px-6 py-3 dark:bg-chuGreen/20">
          <span className="font-medium text-chuGreen dark:text-chuGreen-light">
            {new Date().toLocaleDateString("fr-FR", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
